import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { I18nextProvider } from 'react-i18next';
import OKRPopUpComponent from './okrpop-component';
import okrPopUpReducer from '../../reducers/okrPopUp.reducers';
import KrReducers from '../../../reducers/krDetails.reducers';
import ErrorBoundary from '../../../components/error_boundary/error-boundary';
import i18n from '../../../i18n';
import './okr-popup.scss';
import { UpdateModal } from '../../actions/okr_popup.action';

const rootReducer = combineReducers({
    KrReducers,
    okrPopUpReducer
});

let store:any;
const renderOKRPopUp = (data:any) => {
    const initialState = {
        KrReducers: {},
        okrPopUpReducer: data,
    }
    store = createStore(rootReducer, initialState, applyMiddleware(thunkMiddleware));
    // store.dispatch({type:okrPopUpConstants.UPDATE_INITIAL_PROPS,data});
    // console.log('renderOKRPopUp', data);
    ReactDOM.render(
        <Provider store={store}>
            <ErrorBoundary>
                <Suspense fallback="loading...">
                    <I18nextProvider i18n={i18n}>
                        <OKRPopUpComponent />
                    </I18nextProvider>
                </Suspense>
            </ErrorBoundary>
        </Provider>, document.getElementById('goal-details-page')
    );
}

const closeRenderOKRPopup = () => {
    const okrPopupModalEle = document.querySelector('.react-modal-okr-popup');
    if (okrPopupModalEle) {
        store.dispatch(UpdateModal(false))
    }
}

window.renderOKRPopUp = renderOKRPopUp;
window.closeRenderOKRPopup = closeRenderOKRPopup;
